import { render, staticRenderFns } from "./AddTaggingRule.vue?vue&type=template&id=b3954404&scoped=true"
import script from "./AddTaggingRule.vue?vue&type=script&lang=js"
export * from "./AddTaggingRule.vue?vue&type=script&lang=js"
import style0 from "./AddTaggingRule.vue?vue&type=style&index=0&id=b3954404&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3954404",
  null
  
)

export default component.exports